import moduleProps from '../../../moduleProps'
import { openTimesheetModal } from '../../../State/timesheetModal'

export default (timesheet) => (dispatch) => {

  const { filters } = moduleProps()
  
  // Pass projectId from filters to pre-filter the project dropdown
  const projectId = filters && filters._projectId ? filters._projectId : undefined

  dispatch(openTimesheetModal({ id: timesheet.id, projectId }))

}
